declare let THREE: any;
declare let OBB: any;

export class ObbBuilder {

  protected position: any;
  protected size: any;
  protected bb: any;
  protected rotation: any;
  protected useScale: any;

  constructor() {
    this.position = null;
    this.size = null;
    this.bb = null;
    this.rotation = null;
    this.useScale = false;
  }

  setPosition(pos) {
    this.position = pos;
    return this;
  }

  setSize(size) {
    this.size = size;
    return this;
  }

  setRotation(euler) {
    if (euler instanceof THREE.Euler) {
      this.rotation = euler;
    }
    return this;
  }

  setBoundingBox(bb) {
    this.bb = bb;
    return this;
  }

  useObjectScale(bool) {
    if (typeof (bool) === 'boolean') {
      this.useScale = bool;
    }
    return this;
  }

  build(obj) {

    obj.updateMatrixWorld();

    const mWorld = obj.matrixWorld.clone();

    if (this.position) {
      mWorld.setPosition(this.position);
    }

    const basis = new THREE.Matrix4();

    if (this.rotation) {
      basis.makeRotationFromEuler(this.rotation);
    } else {
      basis.extractRotation(mWorld);
    }

    const position = new THREE.Vector3();
    if (this.position) {
      position.copy(this.position);
    } else {
      obj.getWorldPosition(position);
    }

    const size = new THREE.Vector3();
    if (this.size) {
      size.copy(this.size);
    } else {
      const boundingBox = this.bb || new THREE.Box3().setFromObject(obj);
      boundingBox.getSize(size);
    }

    size.multiplyScalar(0.5);

    if (this.useScale) {
      const scaleVec = new THREE.Vector3();
      mWorld.decompose(new THREE.Vector3(), new THREE.Quaternion(), scaleVec);
      const scaleMatrix = new THREE.Matrix4().makeScale(scaleVec.x, scaleVec.y, scaleVec.z);
      size.applyMatrix4(scaleMatrix);
    }

    return new OBB(position, size, basis);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/collision/obb-builder.service.ts